<template>
  <div class="w-full mt-2 overflow-hidden animate-pulse">
    <div class="flex flex-col gap-2">
      <div
        v-for="n in 3"
        :key="n"
        class="grid lg:grid-cols-12 md:grid-cols-8 grid-cols-1 gap-2 w-full items-center py-3 border-b border-gray-100"
      >
        <div class="md:col-span-1 col-span-12">
          <div class="h-4 w-8 bg-slate-200 rounded"></div>
        </div>
        <div class="md:col-span-3 col-span-12">
          <div class="h-4 w-3/4 bg-slate-200 rounded"></div>
        </div>
        <div class="md:col-span-2 col-span-6">
          <div class="h-4 w-20 bg-slate-200 rounded"></div>
        </div>
        <div class="md:col-span-2 col-span-6">
          <div class="h-4 w-20 bg-slate-200 rounded"></div>
        </div>
        <div class="md:col-span-2 col-span-6 flex items-center gap-2">
          <div class="h-4 w-24 bg-slate-200 rounded"></div>
        </div>
        <div class="md:col-span-2 col-span-6">
          <div class="h-4 w-20 bg-slate-200 rounded"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts"></script>
